export default "__VITE_ASSET__8e1fa988__"